"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @Description: 自建的USS存储
 * @Version: 2.3.3
 * @Date: 2022-07-04 17:40:52
 */
var axios_1 = require("axios");
var utils_1 = require("uss-vod-js-sdk/lib/src/utils");
var __1 = require("..");
var utils_2 = require("../utils");
var utils_3 = require("./utils");
var USSImg = /** @class */ (function (_super) {
    __extends(USSImg, _super);
    function USSImg(options) {
        var _this = _super.call(this) || this;
        _this.options = options;
        _this.$ = axios_1.default.create({
            adapter: (0, utils_3.retryAdapterEnhancer)(axios_1.default.defaults.adapter, {
                times: _this.options.strategy.retry_count,
                delay: _this.options.strategy.backoff_time
            })
        });
        _this.cancelToken = axios_1.default.CancelToken.source();
        return _this;
    }
    USSImg.prototype.upload = function (_a) {
        var file = _a.file, imgId = _a.imgId, imgIndex = _a.imgIndex;
        return __awaiter(this, void 0, void 0, function () {
            var etagSlices, identities, toBeUploadedSlices, index, start, end, size, _b, _c, uploadId, sum, preSum, getLoaded, tasks, queue;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (file.size <= this.options.strategy.slice) {
                            return [2 /*return*/, new Promise(function (resolve, reject) {
                                    _this.normalUpload(file, imgId, imgIndex).then(resolve).catch(reject);
                                })];
                        }
                        etagSlices = [];
                        identities = [];
                        toBeUploadedSlices = [];
                        index = 0;
                        _d.label = 1;
                    case 1:
                        if (!(index < file.size / this.options.strategy.slice)) return [3 /*break*/, 4];
                        start = this.options.strategy.slice * index;
                        end = start + this.options.strategy.slice;
                        size = (end <= file.size ? end : file.size) - start;
                        _c = (_b = etagSlices).push;
                        return [4 /*yield*/, (0, utils_2.getEtag)(file.slice(start, start + size))];
                    case 2:
                        _c.apply(_b, [_d.sent()]);
                        toBeUploadedSlices.push({ index: index, start: start, size: size });
                        _d.label = 3;
                    case 3:
                        index++;
                        return [3 /*break*/, 1];
                    case 4: return [4 /*yield*/, this.prepare(imgId)];
                    case 5:
                        uploadId = _d.sent();
                        sum = [];
                        preSum = 0;
                        getLoaded = function (ind, loaded) {
                            preSum -= sum[ind] || 0;
                            sum[ind] = loaded || 0;
                            preSum += sum[ind];
                            return preSum;
                            // return sum.reduce((prev: number, cur: number) => prev+cur, 0)
                        };
                        tasks = toBeUploadedSlices.map(function (_a) {
                            var start = _a.start, size = _a.size, index = _a.index;
                            return function () { return __awaiter(_this, void 0, void 0, function () {
                                var headers, Axios;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    headers = {
                                        Authorization: this.options.token,
                                        Etag: etagSlices[index],
                                        'X-Request-Id': "".concat(imgId, "-").concat(index + 1),
                                        'Content-Type': __1.ContentTypeHeader.slice,
                                        // 'Content-Length': size,
                                        'X-Slice-Index': index + 1
                                    };
                                    Axios = axios_1.default.create({
                                        adapter: (0, utils_3.retryAdapterEnhancer)(axios_1.default.defaults.adapter, {
                                            times: this.options.strategy.retry_count,
                                            delay: this.options.strategy.backoff_time
                                        }),
                                        onUploadProgress: function (data) {
                                            var totalLoaded = getLoaded(index, data.loaded);
                                            var progress = (0, utils_3.getProgressInfoItem)(totalLoaded, file.size);
                                            _this.options.onProgressCB(__assign(__assign({}, progress), { index: imgIndex }));
                                        }
                                    });
                                    return [2 /*return*/, Axios.post("".concat(this.options.upload_domain, "/api/v3/").concat(this.options.bucket, "/").concat(imgId, "?uploadId=").concat(uploadId), file.slice(start, start + size), {
                                            cancelToken: this.cancelToken.token,
                                            headers: headers
                                        }).then(function (_a) {
                                            var data = _a.data;
                                            return ({
                                                identity: data.data.identity,
                                                size: size,
                                                index: index
                                            });
                                        })];
                                });
                            }); };
                        });
                        queue = new utils_1.Queue(tasks, {
                            concurrency: this.options.strategy.concurrency
                        });
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                var fulfilled = 0;
                                queue.setTaskFullfilledHandler(function (_a) {
                                    var index = _a.index, identity = _a.identity;
                                    return __awaiter(_this, void 0, void 0, function () {
                                        var data, error_1;
                                        return __generator(this, function (_b) {
                                            switch (_b.label) {
                                                case 0:
                                                    identities[index] = identity;
                                                    if (!(++fulfilled === tasks.length)) return [3 /*break*/, 4];
                                                    _b.label = 1;
                                                case 1:
                                                    _b.trys.push([1, 3, , 4]);
                                                    return [4 /*yield*/, this.mergeObject(imgId, imgIndex, etagSlices, identities, uploadId)];
                                                case 2:
                                                    data = _b.sent();
                                                    resolve(data);
                                                    return [3 /*break*/, 4];
                                                case 3:
                                                    error_1 = _b.sent();
                                                    reject(error_1);
                                                    return [3 /*break*/, 4];
                                                case 4: return [2 /*return*/];
                                            }
                                        });
                                    });
                                });
                                queue.setAllTaskFullfilledHandler(function () { });
                                queue.setTaskRejectedHandler(function (error) {
                                    _this.cancel();
                                    reject(error);
                                });
                                queue.start();
                            })];
                }
            });
        });
    };
    USSImg.prototype.prepare = function (imgId) {
        return __awaiter(this, void 0, void 0, function () {
            var uploadId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$.post("".concat(this.options.upload_domain, "/api/v3/prepare/").concat(this.options.bucket, "/").concat(imgId), null, {
                            cancelToken: this.cancelToken.token,
                            headers: {
                                Authorization: this.options.token,
                                'X-Request-Id': imgId,
                                'Content-Type': __1.ContentTypeHeader.image
                            }
                        })];
                    case 1:
                        uploadId = (_a.sent()).data.data.uploadId;
                        return [2 /*return*/, uploadId];
                }
            });
        });
    };
    USSImg.prototype.mergeObject = function (imgId, imgIndex, etagSlices, identities, uploadId) {
        return __awaiter(this, void 0, void 0, function () {
            var params, data, _a, _b, _c;
            var _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        params = {
                            slice_etags: etagSlices.map(function (item, idx) { return ({
                                index: idx + 1,
                                etag: item,
                                identity: identities[idx]
                            }); })
                        };
                        _b = (_a = this.$).post;
                        _c = ["".concat(this.options.upload_domain, "/api/v3/commit/").concat(this.options.bucket, "/").concat(imgId, "?uploadId=").concat(uploadId), params];
                        _d = {};
                        _e = {
                            'X-Request-Id': imgId + '-merge',
                            'Content-Type': __1.ContentTypeHeader.image,
                            Authorization: this.options.token,
                            'X-Slice-Count': etagSlices.length
                        };
                        return [4 /*yield*/, (0, utils_2.getEtag)(new Blob([JSON.stringify(params)]))];
                    case 1: return [4 /*yield*/, _b.apply(_a, _c.concat([(_d.headers = (_e.Etag = _f.sent(),
                                _e),
                                _d.cancelToken = this.cancelToken.token,
                                _d)]))];
                    case 2:
                        data = (_f.sent()).data.data;
                        return [2 /*return*/, {
                                index: imgIndex,
                                url: this.getFileUrl(imgId),
                                etag: data.etag,
                                img_id: imgId
                            }];
                }
            });
        });
    };
    USSImg.prototype.getFileUrl = function (imgId) {
        return this.options.play_domain + '/' + imgId;
    };
    USSImg.prototype.normalUpload = function (file, imgId, imgIndex) {
        return __awaiter(this, void 0, void 0, function () {
            var etag;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, utils_2.getEtag)(file)];
                    case 1:
                        etag = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                var Axios = axios_1.default.create({
                                    adapter: (0, utils_3.retryAdapterEnhancer)(axios_1.default.defaults.adapter, {
                                        times: _this.options.strategy.retry_count,
                                        delay: _this.options.strategy.backoff_time
                                    }),
                                    onUploadProgress: function (data) {
                                        var progress = (0, utils_3.getProgressInfoItem)(data.loaded, data.total);
                                        _this.options.onProgressCB(__assign(__assign({}, progress), { index: imgIndex }));
                                    }
                                });
                                Axios.post("".concat(_this.options.upload_domain, "/api/v3/").concat(_this.options.bucket, "/").concat(imgId), file, {
                                    cancelToken: _this.cancelToken.token,
                                    headers: {
                                        Authorization: _this.options.token,
                                        'X-Request-Id': imgId,
                                        ETag: etag,
                                        'Content-Type': __1.ContentTypeHeader.image
                                        // 'Content-Length': file.size
                                    }
                                })
                                    .then(function (res) {
                                    resolve({
                                        index: imgIndex,
                                        url: _this.getFileUrl(imgId),
                                        etag: res.data.data.etag,
                                        img_id: imgId
                                    });
                                })
                                    .catch(reject);
                            })];
                }
            });
        });
    };
    USSImg.prototype.cancel = function () {
        this.cancelToken.cancel();
    };
    return USSImg;
}(utils_3.ImgUploader));
exports.default = USSImg;
